/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone, navigateTo } from '@helpers';

import Line from '@components/common/line';
import { getBoxShadowStyle } from '@styles/shadow';
import { font } from '@styles/fonts';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export default (props) => {
  const { C } = props;

  const actions = [
    {
      name: i18n.t('Parts'),
      onClick: () => navigateTo('Search', { initialTab: 'parts' }),
    },
    {
      name: i18n.t('Jobs'),
      onClick: () => navigateTo('Search', { initialTab: 'operations' }),
    },
    {
      name: i18n.t('ProductionBatches'),
      onClick: () => navigateTo('Search', { initialTab: 'productionBatches' }),
    },
    {
      name: i18n.t('Production Orders'),
      onClick: () => navigateTo('Search', { initialTab: 'productionOrders' }),
    },
    {
      name: i18n.t('NC Files'),
      onClick: () => navigateTo('Search', { initialTab: 'ncFiles' }),
    },
    {
      name: i18n.t('Tools'),
      onClick: () => navigateTo('Search', { initialTab: 'tools' }),
    },
    {
      name: i18n.t('Images & Documents'),
      onClick: () => navigateTo('Search', { initialTab: 'imagesDocuments' }),
    },
  ];

  return (
    <View
      style={[
        {
          width: '100%',
          paddingBottom: scale(50),
        },
        isPhone
          ? {
              paddingHorizontal: scale(15),
            }
          : {
              paddingHorizontal: scale(180),
            },
      ]}
    >
      <View>
        <Text style={[font.Footnote, { color: C('Label/Light/Tertiary'), marginLeft: scale(15), marginBottom: scale(5) }]}>
          {i18n.t('MASTER TABLES')}
        </Text>
      </View>
      <View
        style={[
          getBoxShadowStyle({ type: 'Field', C }),
          {
            borderRadius: scale(SCREEN_BORDER_RADIUS),
          },
        ]}
      >
        {actions.map((item, index) => (
          <Line
            {...{
              item: {
                ...item,
                noArrow: true,
              },
              index,
              array: actions,
              C,
              roundBottom: actions.length - 1 === index,
              roundTop: index === 0,
              topBorder: index !== 0,
              smallSize: true,
            }}
            key={item.name}
          />
        ))}
      </View>
    </View>
  );
};
